import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';

import { Occupant } from './occupant';
import { zonesMapSelector } from 'core/redux/selectors/zones';
import { IZoneOccupancy } from 'types/redux/zoneGuardsOccupancy';
import { devicesMapSelector } from 'core/redux/selectors/devices';

import styles from './styles.module.css';

interface IZoneOccupanciesProps {
  occupancy: IZoneOccupancy;
}

export const ZoneOccupancy: FC<IZoneOccupanciesProps> = ({ occupancy }) => {
  const devices = useSelector(devicesMapSelector);
  const zones = useSelector(zonesMapSelector);

  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => setIsExpanded((expanded) => !expanded);

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <div className={styles.title}>{zones?.[occupancy.zoneId]?.name || '-'}</div>
        <div className={styles.title}>
          <span className={styles.count}>{occupancy.occupancies.length}</span>
          <button type="button" className={styles.expand} onClick={toggleExpanded} aria-expanded={isExpanded}>
            <span>{isExpanded ? '–' : '+'}</span>
          </button>
        </div>
      </div>
      <div className={`${styles.panel} ${isExpanded ? styles.panelExpanded : ''}`}>
        <div className={styles.panelContent}>
          {occupancy.occupancies.map(({ occupant, enteredAt }, index) => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            return <Occupant key={occupant} name={devices?.[occupant].denomination() || '-'} enteredAt={enteredAt} />;
          })}
        </div>
      </div>
    </div>
  );
};
